import React from 'react';

const MaintenanceOverlay = () => (
  <div className="fixed inset-0 z-[9999] bg-gradient-custom flex flex-col items-center justify-center w-full h-full text-gray-900 overflow-hidden">
    {/* Animated Glow Background */}
    <div className="glow glow-1"></div>
    <div className="glow glow-2"></div>
    {/* Main Content */}
    <div className="flex flex-col items-center justify-center min-h-screen w-full px-4">
      {/* Extra space above logo for 'alien/cute guy' effect */}
      <div className="h-16 sm:h-24"></div>
      {/* Logo Branding */}
      <div className="mb-10 flex flex-col items-center">
        <div className="relative mb-3">
          <div className="w-16 h-16 rounded-xl shadow-lg bg-gradient-to-br from-[#0670c4] to-[#0c8ee7] flex items-center justify-center rotate-[-3deg]">
            <svg className="w-12 h-12 p-1.5 text-gray-900 drop-shadow-md" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              <path d="M9 22c0-3 1.5-5.5 3-5.5s3 2.5 3 5.5"/>
              <circle cx="12" cy="12" r="3"/>
              <path d="M12 9v6"/>
              <path d="M9 12h6"/>
            </svg>
          </div>
          <div className="absolute -inset-1 bg-gradient-to-br from-[#bae0fd] to-[#0c8ee7] opacity-40 blur-lg rounded-xl"></div>
        </div>
        <div className="flex flex-col items-center">
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-extrabold text-gray-900">icon</span><span className="text-2xl font-normal bg-gradient-to-r from-[#0670c4] via-[#0c8ee7] to-[#36a9f8] bg-clip-text text-transparent">vertify</span><span className="ml-1 text-xs text-[#36a9f8]/60 font-light">beta</span>
          </div>
          <span className="text-xs text-gray-400 font-normal tracking-wider uppercase mt-1">CONVERT ANYTHING</span>
        </div>
      </div>
      {/* Main Content */}
      <div className="text-center max-w-xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 bg-gradient-to-r from-gray-900 to-[#0c8ee7] bg-clip-text text-transparent">
          System Upgrade in Progress
        </h1>
        <p className="text-gray-700 text-lg mb-4">
          We're enhancing our conversion engine to deliver faster, more accurate results.<br />
          <span className="text-[#0c8ee7]">Thank you for your patience!</span>
        </p>
        <p className="text-gray-500 text-base mt-2">
          iconvertify is trusted by professionals and students worldwide for secure, high-quality file and unit conversions.<br />
          <span className="text-gray-400">No registration required. Your privacy, our priority.</span>
        </p>
      </div>
    </div>
    {/* Custom styles for glow and font */}
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
      * { font-family: 'Inter', sans-serif; }
      .bg-gradient-custom {
        background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
      }
      .glow {
        position: absolute;
        width: 500px;
        height: 500px;
        border-radius: 50%;
        background: radial-gradient(circle at center, rgba(16, 185, 129, 0.15), transparent 70%);
        pointer-events: none;
        z-index: 0;
      }
      .glow-1 {
        top: -250px;
        left: -250px;
        animation: float 8s infinite;
      }
      .glow-2 {
        bottom: -250px;
        right: -250px;
        animation: float 8s infinite reverse;
      }
      @keyframes float {
        0%, 100% { transform: translate(0, 0); }
        50% { transform: translate(50px, 50px); }
      }
    `}</style>
  </div>
);

export default MaintenanceOverlay; 